import React from "react";
import { Pressable, View } from "react-native";
import StandardText from "../standardText/StandardText";

const SimpleNotification = ({message, description, onDismissPress}) => {
    const handleOnNotificationPress = () => {
        if (onDismissPress) {
            onDismissPress();
        }
    };
    const descriptionTruncated = description && description.length > 100 ? `${description.substring(0, 97)}...` : description;

    return (
        <View>
            <Pressable
                onPress={() => handleOnNotificationPress()}
                style={{
                    backgroundColor: 'rgba(30, 30, 30, 0.9)',
                    justifyContent: 'center',
                    borderRadius: 4,
                    padding: 15,
                }}>
                <StandardText style={{ color: 'white', lineHeight: 30, fontWeight: 700 }}>{message}</StandardText>
                {descriptionTruncated && (
                    <StandardText style={{ color: 'white', lineHeight: 30, marginTop: 4 }}>{descriptionTruncated}</StandardText>
                )}
            </Pressable>
        </View>
    );
};

export default SimpleNotification;